import { render } from "./keywordAddtotaskView.vue?vue&type=template&id=11882b0b&scoped=true"
import script from "./keywordAddtotaskView.vue?vue&type=script&lang=js"
export * from "./keywordAddtotaskView.vue?vue&type=script&lang=js"

import "./keywordAddtotaskView.vue?vue&type=style&index=0&id=11882b0b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11882b0b"]])

export default __exports__